import useStateRef from 'react-usestateref'

const useLocalState = (storageKey, defaultValue, callback) => {
  let storedValue = localStorage.getItem(storageKey)

  if(storedValue) {
    try {
      storedValue = JSON.parse(storedValue)
    } catch {
      storedValue = defaultValue
    }
    if(callback && typeof callback === 'function') {
      storedValue = callback(storedValue, defaultValue)
    }
  }

  const [value, setValue, ref] = useStateRef(storedValue ?? defaultValue)

  const setLocalValue = (newValue, setLocally=true) => {
    if(setLocally) localStorage.setItem(storageKey, JSON.stringify(newValue))
    setValue(newValue)
  }

  return [value, setLocalValue, ref]
}

export default useLocalState
